
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["feedback_1_svg__iconSvg",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 65 65","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"1.414","class":"feedback_1_svg__iconSvg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.913 28.91a5.657 5.657 0 100-11.314 5.657 5.657 0 000 11.313zM44.087 28.91a5.657 5.657 0 100-11.314 5.657 5.657 0 000 11.313zM18.27 48.306c.582-.433 14.43-10.468 28.464 0l2.428-3.258c-16.504-12.311-33.158-.12-33.325.002l2.432 3.256z"}}),_c('path',{attrs:{"d":"M9.164 65h46.672C60.888 65 65 60.888 65 55.836V9.164C65 4.111 60.888 0 55.836 0H9.164C4.112 0 0 4.111 0 9.164v46.672C0 60.888 4.112 65 9.164 65zM4.063 9.164a5.108 5.108 0 015.101-5.101h46.672a5.108 5.108 0 015.102 5.101v46.672a5.108 5.108 0 01-5.102 5.102H9.164a5.108 5.108 0 01-5.101-5.102V9.164z"}})])
          )
        }
      }
    